import type { UserRole } from "@onsand/api";

// `bis` is a capability role, not a rank: it grants no admin access, so this is a set check.
const STAFF_ROLES: readonly UserRole[] = ["admin", "super_admin"];

export type Admission = "admitted" | "denied";

/** The session boundaries the gate drives; the login form wires the live ones. */
export type StaffSession = {
	storeToken(token: string): void;
	clearToken(): void;
	/** Reads the signed-in user's role; authenticates from the stored token. */
	fetchRole(): Promise<UserRole>;
	endSession(): Promise<void>;
};

/**
 * The gate every sign-in method passes through. Stores the fresh token, then lets only
 * staff roles stay signed in.
 */
export async function admitStaff(
	user: { getIdToken(): Promise<string> },
	session: StaffSession,
): Promise<Admission> {
	session.storeToken(await user.getIdToken());
	if (STAFF_ROLES.includes(await session.fetchRole())) return "admitted";

	// Ending the Firebase session too: the token refresher would otherwise revive the cookie.
	session.clearToken();
	await session.endSession();
	return "denied";
}
